import React from 'react';
import { Route } from 'react-router-dom';

import IdaasCallback from './IdaasCallback';

MfaRoutes.defaultProps = {
  baseUrl: undefined,
};

/**
 * Defines routes for MFA Prompt.
 */
export default function MfaRoutes({ baseUrl }: { baseUrl?: string }) {
  return (
    <Route
      path={`${baseUrl ?? ''}/gen2/mfa-prompt/idaas`}
      component={IdaasCallback}
    />
  );
}
